export const handleClick = (event: React.MouseEvent<HTMLInputElement>) => {
  event.currentTarget.select();
};
